/**
 * Nombres de peces y señas de identificación, segunda centena: español.
 *
 * Sobre por qué este archivo va aparte, véase species-world-ru.ts.
 *
 * ⚠️ EL NOMBRE QUE EL PESCADOR BUSCA, no una traducción del latín. «Barbo
 * comizo», «black bass», «barramundi», «arapaima» y «dorado» se dicen así;
 * inventar «lucioperca americana» escondería el pez de quien lo busca.
 */
export const МИР_ES: Record<string, string> = {
  // ── Iberia e Italia ─────────────────────────────────────────────────────
  'fish.iberian_barbel': 'barbo común ibérico',
  'fish.iberian_barbel_look':
    'Alargado, de bronce oliváceo, cuatro barbillas y boca inferior. Se pone en las pozas bajo los rápidos.',
  'fish.comizo_barbel': 'barbo comizo',
  'fish.comizo_barbel_look':
    'Barbo de morro largo y boca casi de lucio: el único que caza alevines. Se queda en lo hondo.',
  'fish.gitano_barbel': 'barbo gitano',
  'fish.gitano_barbel_look':
    'Menor y más oscuro que sus primos, con el flanco moteado. Entra en banco al cebadero.',
  'fish.ebro_barbel': 'barbo del Ebro',
  'fish.ebro_barbel_look':
    'Recio, gris dorado, de labios gruesos. Tira en la corriente más que una carpa del doble de peso.',
  'fish.iberian_nase': 'boga del Tajo',
  'fish.iberian_nase_look':
    'Plateada, de dorso oscuro y boca transversal por debajo. Raspa las piedras en banco sobre la corriente.',
  'fish.iberian_chub': 'cacho ibérico (bordallo)',
  'fish.iberian_chub_look':
    'Menor que el cacho del norte, de escama grande y dorso oscuro. Se esconde bajo los arbustos.',
  'fish.italian_barbel': 'barbo italiano',
  'fish.italian_barbel_look':
    'Estilizado, con el dorso oscuro y moteado y cuatro barbillas. Se tumba en las tablas del Po.',
  'fish.italian_chub': 'cavedano',
  'fish.italian_chub_look':
    'Cabezón y plateado, con cada escama ribeteada de oscuro. Come en superficie y pelea a tus pies.',
  'fish.italian_roach': 'triotto',
  'fish.italian_roach_look':
    'Pequeña, plateada, de ojo amarillo. Forma bancos apretados en los canales de Lombardía.',
  'fish.italian_pike': 'lucio italiano',
  'fish.italian_pike_look':
    'Lucio del sur: el flanco lleva pintas claras en vez de barras amarillas. Vive en meandros y lagos.',
  'fish.agone': 'agone',
  'fish.agone_look':
    'El sábalo de los lagos alpinos: estrecho, plateado, con una mancha oscura tras el opérculo.',

  // ── Balcanes, Danubio y Mesopotamia ─────────────────────────────────────
  'fish.danube_shad': 'sábalo del Danubio',
  'fish.danube_shad_look':
    'Plateado, con quilla en el vientre y una fila de manchas oscuras. Sube el Danubio cada abril.',
  'fish.softmouth_trout': 'trucha de boca blanda',
  'fish.softmouth_trout_look':
    'Trucha de los ríos kársticos, de morro blando y saliente y pintas finas. Vive en agua cristalina.',
  'fish.dentex_trout': 'trucha dentex',
  'fish.dentex_trout_look':
    'Trucha balcánica depredadora, dentada y de cuerpo alto. Ataca al alburno en la superficie.',
  'fish.ohrid_trout': 'trucha de Ohrid',
  'fish.ohrid_trout_look':
    'Trucha plateada del lago Ohrid con escasas manchas negras. Se queda honda todo el año.',
  'fish.schraetzer': 'acerina rayada',
  'fish.schraetzer_look':
    'Acerina estrecha y rayada, de morro alargado: líneas oscuras recorren el flanco. Pegada al fondo.',
  'fish.greek_catfish': 'siluro de Aristóteles',
  'fish.greek_catfish_look':
    'El siluro de los ríos del Epiro: más corto que el europeo, cabezón y con solo dos barbillas.',
  'fish.tigris_barbel': 'barbo mangar',
  'fish.tigris_barbel_look':
    'Barbo enorme del Tigris y el Éufrates con morro de lucio. Acecha alevines en las pozas hondas.',
  'fish.shabut': 'shabut',
  'fish.shabut_look':
    'Barbo dorado de cuerpo alto, labios gruesos y escama grande. Come en el fondo de ríos cálidos.',
  'fish.mesopotamian_catfish': 'siluro mesopotámico',
  'fish.mesopotamian_catfish_look':
    'Siluro del Tigris y el Éufrates: más claro que el europeo y jaspeado. Yace en las fosas hondas.',

  // ── Europa occidental y del norte ───────────────────────────────────────
  'fish.blaufelchen': 'coregono blaufelchen',
  'fish.blaufelchen_look':
    'Coregono del lago Constanza, de dorso azulado y boca pequeña. Suspendido a gran profundidad.',
  'fish.alpine_char': 'salvelino alpino',
  'fish.alpine_char_look':
    'Salvelino de lagos de montaña: dorso oscuro, manchas rosas, aletas bajas ribeteadas de blanco.',
  'fish.aquitanian_pike': 'lucio aquitano',
  'fish.aquitanian_pike_look':
    'Lucio del suroeste de Francia: menor que el común, con el flanco jaspeado de oliva. Acecha en la hierba.',
  'fish.danube_roach': 'rutilo del Danubio',
  'fish.danube_roach_look':
    'Rutilo grande y de cuerpo alto con aletas anaranjadas. Recorre el cauce del Danubio en bancos.',
  'fish.pearlfish': 'rutilo perlado',
  'fish.pearlfish_look':
    'Rutilo pesado de los lagos prealpinos; en la freza el flanco se cubre de granos nacarados.',
  'fish.minnow': 'piscardo',
  'fish.minnow_look':
    'Diminuto y moteado, con manchas oscuras en el flanco; en la freza el vientre se vuelve rojo.',
  'fish.brook_lamprey': 'lamprea de arroyo',
  'fish.brook_lamprey_look':
    'Lamprea pequeña de arroyos limpios: serpentina y sin mandíbulas. De adulta no come nada.',
  'fish.mediterranean_barbel': 'barbo mediterráneo',
  'fish.mediterranean_barbel_look':
    'Barbo pequeño con el flanco moteado y la cola anaranjada. Vive en los rápidos de piedra.',
  'fish.apron': 'apron del Ródano',
  'fish.apron_look':
    'Pequeña perca larga y cilíndrica del Ródano, con bandas oscuras. Pegada al fondo en agua rápida.',
  'fish.topmouth_gudgeon': 'pseudorasbora',
  'fish.topmouth_gudgeon_look':
    'Invasor diminuto de boca hacia arriba y raya oscura en el flanco. Se adueña de las balsas quietas.',
  'fish.peipus_whitefish': 'coregono del lago Peipus',
  'fish.peipus_whitefish_look':
    'Coregono del lago Peipus: plateado, de frente recta y boca inferior. Come sobre la arena.',

  // ── Europa oriental, Cáucaso, Asia Central y Siberia ────────────────────
  'fish.amur_redfin': 'aspio del Amur',
  'fish.amur_redfin_look':
    'Estilizado y plateado, de cabeza plana y aletas carmesí. Golpea a los alevines en la corriente.',
  'fish.mongolian_redfin': 'culter mongol',
  'fish.mongolian_redfin_look':
    'Depredador del Amur de boca levantada y aletas rojizas. Caza a media agua en los brazos del río.',
  'fish.balkhash_marinka': 'marinka del Baljash',
  'fish.balkhash_marinka_look':
    'Oliva oscura y cilíndrica, dos pares de barbillas y boca inferior. Come sobre fondo de piedra.',
  'fish.common_marinka': 'marinka',
  'fish.common_marinka_look':
    'Pez gris plateado de los ríos de montaña, de labios gruesos. Toma insectos caídos en la corriente.',
  'fish.naked_osman': 'osman desnudo',
  'fish.naked_osman_look':
    'Casi sin escamas, pardo oscuro, con barbillas en la boca inferior. Vive entre las rocas del Issyk-Kul.',
  'fish.altai_osman': 'osman de Altái',
  'fish.altai_osman_look':
    'Recio, gris verdoso y cabezón. En los lagos de montaña se hace depredador y caza peces pequeños.',
  'fish.khramulya': 'jramulia',
  'fish.khramulya_look':
    'Dorso oscuro, flanco plateado, boca inferior con borde córneo. Raspa las algas de las piedras.',
  'fish.bulatmai_barbel': 'barbo bulatmai',
  'fish.bulatmai_barbel_look':
    'Barbo grande del Kurá y el Aras, gris dorado y de labios gruesos. Trabaja el fondo en la corriente.',
  'fish.pike_asp': 'aspio lucio',
  'fish.pike_asp_look':
    'El aspio en forma de lucio del Amu Daria: largo, plateado, de cabeza plana. Caza en las crecidas.',
  'fish.balkhash_perch': 'perca del Baljash',
  'fish.balkhash_perch_look':
    'Perca sin rayas: gris uniforme, con cresta espinosa. Vive junto a la vegetación y los troncos.',
  'fish.baikal_grayling': 'tímalo negro del Baikal',
  'fish.baikal_grayling_look':
    'Oscuro, casi violáceo, con una vela dorsal enorme y moteada. Se pone sobre las rocas de la orilla.',
  'fish.round_whitefish': 'coregono cilíndrico',
  'fish.round_whitefish_look':
    'Coregono de cuerpo redondo y boca pequeña por debajo. Yace en la grava de los ríos del norte.',
  'fish.humpback_whitefish': 'coregono jorobado',
  'fish.humpback_whitefish_look':
    'Coregono jorobado de cabeza aplanada y boca inferior. Come en el lecho de los ríos siberianos.',
  'fish.brown_bullhead': 'bagre enano pardo',
  'fish.brown_bullhead_look':
    'Bagre pardo de cola cuadrada y ocho barbillas. Ahoga las balsas pequeñas y pica todo el año.',

  // ── Salmones del Pacífico ───────────────────────────────────────────────
  'fish.chinook': 'salmón chinook',
  'fish.chinook_look':
    'El mayor salmón del Pacífico: dorso oscuro con pintas negras y encías negras. Descansa en las fosas.',
  'fish.coho': 'salmón coho',
  'fish.coho_look':
    'Plata viva y cola ancha; en el río el flanco se inunda de carmesí. Aguanta en la corriente.',
  'fish.chum': 'salmón keta',
  'fish.chum_look':
    'En el río se cubre de barras moradas y las mandíbulas se curvan. Sube por el cauce a desovar.',
  'fish.pink_salmon': 'salmón rosado',
  'fish.pink_salmon_look':
    'Salmón pequeño con grandes manchas negras en la cola; el macho de río cría una joroba.',
  'fish.masu': 'salmón masu',
  'fish.masu_look':
    'Salmón plateado con banda rosa y manchas oscuras. El único que vive solo en Asia.',
  'fish.sakhalin_taimen': 'taimen de Sajalín',
  'fish.sakhalin_taimen_look':
    'Dorso oscuro, aletas rojizas, boca ancha. Vive en los estuarios y bajos de los ríos de Sajalín.',

  // ── Asia oriental ───────────────────────────────────────────────────────
  'fish.herabuna': 'carpín herabuna',
  'fish.herabuna_look':
    'Carpín alto y plano con la aleta anal muy larga. Come a media agua y no del fondo.',
  'fish.ugui': 'leucisco ugui',
  'fish.ugui_look':
    'El leucisco japonés: plateado, con tres bandas naranjas en la freza. Se mueve en bancos.',
  'fish.hasu': 'hasu',
  'fish.hasu_look':
    'Pequeño depredador de boca curvada y reflejo azulado. Caza alevines en la superficie de los lagos.',
  'fish.wuchang_bream': 'brema de Wuchang',
  'fish.wuchang_bream_look':
    'Brema corta y alta, de espalda recta y escama fina. Vive a media agua en balsas y embalses.',
  'fish.chinese_culter': 'culter chino',
  'fish.chinese_culter_look':
    'Plano y plateado, con la boca muy levantada y la espalda recta. Persigue alevines por arriba.',
  'fish.barbel_steed': 'hemibarbo',
  'fish.barbel_steed_look':
    'Estilizado, de morro largo, labio grueso y un par de barbillas. Escarba el fondo de arena.',
  'fish.amur_wels': 'siluro del Amur',
  'fish.amur_wels_look':
    'Menor que el europeo, cuatro barbillas y flanco moteado. Yace bajo troncos en brazos tranquilos.',
  'fish.biwa_catfish': 'siluro del lago Biwa',
  'fish.biwa_catfish_look':
    'Siluro grande del lago Biwa, de boca ancha y cuerpo corto. Sale a los bajíos al anochecer.',
  'fish.mandarin_fish': 'perca mandarina',
  'fish.mandarin_fish_look':
    'Perca manchada con cresta espinosa y flanco jaspeado. Acecha en el fondo entre las piedras.',
  'fish.leopard_mandarin': 'perca mandarina leopardo',
  'fish.leopard_mandarin_look':
    'Menor que la mandarina, con el flanco cubierto de manchas redondas. Vive en ríos de montaña.',
  'fish.ayu': 'ayu',
  'fish.ayu_look':
    'Esbelto, verde translúcido, con una mancha amarilla en el opérculo; huele a melón. Pasta las piedras.',
  'fish.wakasagi': 'eperlano wakasagi',
  'fish.wakasagi_look':
    'Eperlano diminuto de los lagos de Japón: semitransparente con una banda plateada. Va en bancos.',
  'fish.iwana': 'salvelino iwana',
  'fish.iwana_look':
    'Salvelino de los arroyos japoneses: dorso oscuro, puntos blancos, vientre naranja. Bajo las piedras.',
  'fish.yamame': 'trucha yamame',
  'fish.yamame_look':
    'La forma de río del masu: manchas ovaladas oscuras en el flanco y puntos rojos. Vive en agua fría.',
  'fish.japanese_eel': 'anguila japonesa',
  'fish.japanese_eel_look':
    'Serpentina, gris oscura, con el vientre claro y branquias diminutas. Sale a los bajíos de noche.',
  'fish.amur_sturgeon': 'esturión del Amur',
  'fish.amur_sturgeon_look':
    'Esturión de morro agudo con hileras de escudos óseos, más oscuro que el ruso. Trabaja el lecho.',

  // ── América del Norte ───────────────────────────────────────────────────
  'fish.walleye': 'lucioperca americana (walleye)',
  'fish.walleye_look':
    'Ojos lechosos que reflejan la luz, colmillos y punta blanca en la cola. Trabaja los cortados.',
  'fish.yellow_perch': 'perca amarilla',
  'fish.yellow_perch_look':
    'Amarilla viva, con siete barras oscuras y ventrales naranjas. Se mueve en bancos apretados.',
  'fish.muskellunge': 'muskellunge',
  'fish.muskellunge_look':
    'Lucio enorme, de flanco claro con barras oscuras y cola ahorquillada. Acecha junto a la hierba.',
  'fish.black_crappie': 'crappie negro',
  'fish.black_crappie_look':
    'De cuerpo alto y plateado, salpicado de negro sin orden. Se agrupa junto a árboles sumergidos.',
  'fish.bluegill': 'pez sol de agallas azules',
  'fish.bluegill_look':
    'Redondo y vistoso, con una lengüeta azul en el opérculo. Ronda la hierba y pica a todo.',
  'fish.blue_catfish': 'bagre azul',
  'fish.blue_catfish_look':
    'Gris azulado, con la anal de borde recto y la cola ahorquillada. Aguanta el cauce en la corriente.',
  'fish.flathead_catfish': 'bagre de cabeza plana',
  'fish.flathead_catfish_look':
    'Cabeza aplanada, mandíbula inferior saliente, flanco pardo amarillento. Acecha entre troncos.',
  'fish.american_lake_trout': 'trucha de lago americana',
  'fish.american_lake_trout_look':
    'Gran salvelino de los Grandes Lagos: oscuro, con manchas claras y cola muy ahorquillada.',
  'fish.brook_char': 'trucha de arroyo americana',
  'fish.brook_char_look':
    'Dorso jaspeado, puntos rojos con halo azul y borde blanco en las aletas bajas.',
  'fish.striped_bass': 'lubina rayada',
  'fish.striped_bass_look':
    'Plateada, con siete rayas oscuras a lo largo del flanco. Acorrala bancos de carnada a media agua.',
  'fish.longnose_gar': 'pez caimán narigudo',
  'fish.longnose_gar_look':
    'Cuerpo largo acorazado y morro estrecho y dentado, el doble de largo que la cabeza.',
  'fish.alligator_gar': 'pez caimán del Misisipi',
  'fish.alligator_gar_look':
    'Gigante en coraza de placas romboidales, con mandíbula corta de cocodrilo y dos filas de dientes.',
  'fish.lake_sturgeon': 'esturión de lago',
  'fish.lake_sturgeon_look':
    'Esturión oscuro de morro romo y escudos grandes. Come en el fondo de lagos y ríos profundos.',
  'fish.white_sturgeon': 'esturión blanco',
  'fish.white_sturgeon_look':
    'El mayor pez de América del Norte: gris blanquecino, con cuatro barbillas ante una boca ancha.',

  // ── Trópicos y hemisferio sur ───────────────────────────────────────────
  'fish.golden_mahseer': 'mahseer dorado',
  'fish.golden_mahseer_look':
    'Escamas doradas del tamaño de una mano, labios gruesos y cola potente. Vive en pozas del Himalaya.',
  'fish.rohu': 'rohu',
  'fish.rohu_look':
    'Azul plateado, de frente abombada y boca hacia abajo. Come a media agua en ríos cálidos.',
  'fish.siamese_carp': 'carpa siamesa gigante',
  'fish.siamese_carp_look':
    'Carpa enorme de cuerpo alto, cabeza desmedida y escama grande. Trabaja el lecho del Mekong.',
  'fish.goonch': 'goonch',
  'fish.goonch_look':
    'Bagre aplanado de boca ancha, barbillas largas y flanco manchado. Aguanta tras las rocas.',
  'fish.wallago': 'wallago',
  'fish.wallago_look':
    'Bagre plano y plateado cuya boca pasa del ojo, con dos barbillas. Acecha bajo la orilla.',
  'fish.mekong_catfish': 'bagre gigante del Mekong',
  'fish.mekong_catfish_look':
    'Gigante sin barbillas y casi sin dientes, gris acero y de ojos pequeños. Cruza el Mekong a media agua.',
  'fish.giant_pangasius': 'pangasius gigante',
  'fish.giant_pangasius_look':
    'Pangasius oscuro con aletas alargadas como hilos y una cresta dorsal muy alta.',
  'fish.redtail_catfish': 'bagre de cola roja',
  'fish.redtail_catfish_look':
    'Dorso negro, raya blanca en el flanco y cola rojo vivo. Sale a cazar cuando oscurece.',
  'fish.giant_snakehead': 'cabeza de serpiente gigante',
  'fish.giant_snakehead_look':
    'Cabeza de serpiente, dorsal larguísima, flanco con barras negras. Guarda una nube roja de crías.',
  'fish.peacock_bass': 'pavón (peacock bass)',
  'fish.peacock_bass_look':
    'Verde dorado, con tres barras oscuras y un ocelo en la cola. Ataca alevines junto a los troncos.',
  'fish.dorado': 'dorado',
  'fish.dorado_look':
    'Escamas doradas, cola roja, cabeza roma de boca ósea. Salta fuera del agua como un salmón.',
  'fish.traira': 'tararira',
  'fish.traira_look':
    'Cilíndrica y parda, con boca ancha y dentada. Acecha entre la hierba de los remansos pequeños.',
  'fish.tambaqui': 'tambaquí',
  'fish.tambaqui_look':
    'De cuerpo alto y gris negruzco, con dientes casi humanos: tritura nueces y semillas caídas.',
  'fish.tigerfish': 'pez tigre',
  'fish.tigerfish_look':
    'Flanco plateado con rayas longitudinales y colmillos que asoman con la boca cerrada.',
  'fish.goliath_tiger': 'pez tigre goliat',
  'fish.goliath_tiger_look':
    'El pez tigre del Congo, tan largo como una persona: treinta y dos colmillos y aletas rojas.',
  'fish.nile_perch': 'perca del Nilo',
  'fish.nile_perch_look':
    'Oliva plateada, de espalda jorobada y ojo amarillo. Se pone en cortados profundos y roca.',
  'fish.barramundi': 'barramundi',
  'fish.barramundi_look':
    'Plateado, de frente cóncava y cola alta; el ojo brilla en rosa. Recorre estuarios y ríos.',
  'fish.murray_cod': 'bacalao de Murray',
  'fish.murray_cod_look':
    'Pez pesado con jaspeado verde y boca ancha. Vive bajo el mismo tronco durante décadas.',
  'fish.arapaima': 'arapaima',
  'fish.arapaima_look':
    'Gigante de grandes escamas rojas; respira aire y sube a la superficie cada cuarto de hora.',
};
